import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import icon_colidee from "../../../assets/images/tools/icon_colidee.png";
import icon_teams from "../../../assets/images/tools/icon_teams.png";
import genericAvatar from "../../../assets/images/generic-avatar.jpeg";
import { Card, Image, Nav } from "react-bootstrap";
import { toDateTimeFR } from "../../../utils/datesHeures";
import {
  MdEmail,
  MdLocationOn,
  MdOutlineInfo,
  MdPhoneIphone,
  MdAccountBox,
  MdDescription,
} from "react-icons/md";
import { FaRegQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";
import { selectReduxInstance } from "../../../redux/ReduxInstance";
import ComponentLoader from "../../layout/ComponentLoader";
import ComponentThemesContribution from "../colidee/ComponentThemesContribution";
import ComponentRangeSlider from "../../layout/ComponentRangeSlider";

const PersonneCardInfo = (props) => {
  const { t } = useTranslation();
  const { personne, lastContrib, tabKey, setTabKey, lastContribOnAllEspaces } = props;
  const ReduxInstance = useSelector(selectReduxInstance);

  const filterProcesses = (orgunits, orgName) => {
    if (!orgName) {
      return orgunits;
    }

    if (Array.isArray(orgName)) {
      return orgunits.filter((org) => {
        const types = Array.isArray(org.type) ? org.type : [org.type];
        return types.some((t) => orgName.includes(t)) && !org.enSommeil;
      });
    } else {
      return orgunits.filter((org) => {
        return org.type.includes(orgName) && !org.enSommeil;
      });
    }
  };

  const afficheNonRenseigne = (rituels) => {
    let afficheTitre = t("public.componentPersonne.nonRenseigne");
    rituels.map((elem, key) => {
      if (elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation) {
        afficheTitre = "";
      }
    });

    return afficheTitre;
  };

  const afficheNonRenseigneScope = (rituels, scope) => {
    let afficheTitre = t("public.componentPersonne.nonRenseigne");
    rituels.map((elem, key) => {
      if (
        elem.orgUnitParent === ReduxInstance.orgunitPrincipalInOperation &&
        elem.scope === scope
      ) {
        afficheTitre = "";
      }
    });

    return afficheTitre;
  };

  const scrollBloc = (ID) => {
    setTimeout(function () {
      document.getElementById(ID).scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const retourneLettresMBTI = () => {
    let profil = "";
    let lettreSupplementaire = "";

    profil += personne.lettresMbti[0] > 50 ? "I" : "E";
    profil += personne.lettresMbti[1] > 50 ? "N" : "S";
    profil += personne.lettresMbti[2] > 50 ? "F" : "T";
    profil += personne.lettresMbti[3] > 50 ? "P" : "J";
    lettreSupplementaire = personne.lettresMbti[4] > 50 ? "T" : "A";

    return (
      <a
        href={process.env.REACT_APP_URL_EASYGOUV + "profilsMBTI/" + profil + ".pdf"}
        target="_blank"
        rel="noreferrer"
        className="d-flex align-items-center"
      >
        {profil}-{lettreSupplementaire}{" "}
        <FaRegQuestionCircle size=".8em" className="ms-2" color="#CCC" />
      </a>
    );
  };
  return (
    <Card
      border={"black"}
      id={personne._id}
      className={personne.marque && personne.marque.pinned ? "containerMarquePinned" : ""}
    >
      <Card.Header>
        <Nav
          variant="tabs"
          activeKey={tabKey}
          onSelect={(selectedKey) => {
            setTabKey(selectedKey);
            scrollBloc(personne._id);
          }}
        >
          <Nav.Item>
            <Nav.Link eventKey="informations">
              <MdOutlineInfo />
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="rituels">{t("public.componentPersonne.onglet1")}</Nav.Link>
          </Nav.Item>
          {(ReduxInstance.orgunitPrincipalInOperation ||
            ReduxInstance.espacePrincipalColidee !== 0) && (
            <Nav.Item>
              <Nav.Link eventKey="missions">{t("public.componentPersonne.onglet2")}</Nav.Link>
            </Nav.Item>
          )}
          <Nav.Item>
            <Nav.Link eventKey="roles">{t("public.componentPersonne.onglet3")}</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="participation">{t("public.componentPersonne.onglet4")}</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="profilmbti">{t("public.componentPersonne.onglet5")}</Nav.Link>
          </Nav.Item>
        </Nav>
      </Card.Header>
      <Card.Body>
        <div className="d-flex flex-row">
          <Image
            role="button"
            className="avatar"
            style={{ height: 150 }}
            src={
              personne.profilePic
                ? process.env.REACT_APP_URL_EXPRESS + "images/avatar/" + personne.profilePic
                : genericAvatar
            }
          />

          <div style={{ flex: 1, fontSize: 12, marginLeft: 8 }}>
            <h4> {personne.prenom + " " + personne.nom}</h4>
            {tabKey === "informations" && (
              <>
                <h4>
                  {personne.email && (
                    <div className="float-end">
                      <a
                        style={{ marginRight: 8 }}
                        href={
                          process.env.REACT_APP_URL_COLIDEE +
                          "/redirectMailColideurToIdProfile?email=" +
                          personne.email
                        }
                        target="_blank"
                        rel="noreferrer"
                      >
                        <Image className="icon" src={icon_colidee} />
                      </a>
                      {personne.marque && personne.marque.moduleTeams && (
                        <a
                          href={"https://teams.microsoft.com/l/chat/0/0?users=" + personne.email}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <Image className="icon" src={icon_teams} />
                        </a>
                      )}
                    </div>
                  )}
                </h4>
                <p>
                  {t("public.componentPersonne.fromOrganisation")}{" "}
                  {personne.marque ? personne.marque.nom : "-"}
                </p>
                {/* <p>
                  Dans la société {personne.marque ? personne.marque.nom : ""} depuis le{" "}
                  {personne.dateEmbauche ? toDateParseFR(personne.dateEmbauche) : "-"}
                </p> */}
                <p>
                  <MdPhoneIphone size="1.5em" className="me-1" />
                  {personne.telephone ? (
                    <a href={`tel:${personne.telephone}`}>{personne.telephone}</a>
                  ) : (
                    "-"
                  )}
                </p>
                <p>
                  <MdEmail size="1.5em" className="me-1" />
                  {personne.email ? <a href={`mailto:${personne.email}`}>{personne.email}</a> : "-"}
                </p>
                <p>
                  <MdLocationOn size="1.5em" className="me-1" />
                  {personne.localisations && personne.localisations.length
                    ? personne.localisations.map((element, key) => (
                        <Link to={"/espaces?localisation=" + element._id} key={element._id}>
                          {key >= 1 ? "," : ""}
                          <span className={key >= 1 ? "ms-1" : ""}>{element.nom}</span>
                        </Link>
                      ))
                    : "-"}
                </p>
                <p>
                  {personne.urlCv ? (
                    <a href={personne.urlCv} target="_blank" rel="noreferrer">
                      <MdDescription size="1.5em" className="me-1" />{" "}
                      {t("public.componentPersonne.cv")}
                    </a>
                  ) : (
                    ""
                  )}
                </p>
                <p>
                  {personne.urlPortrait ? (
                    <a href={personne.urlPortrait} target="_blank" rel="noreferrer">
                      <MdAccountBox size="1.5em" className="me-1" />{" "}
                      {t("public.componentPersonne.portrait")}
                    </a>
                  ) : (
                    ""
                  )}
                </p>
              </>
            )}
            {tabKey === "rituels" && personne && (
              <>
                {filterProcesses(personne.orgUnitsParent, "Rituel").length ? (
                  <>
                    {t("public.componentPersonne.rituelsGouvernance")} :
                    <ul>
                      {filterProcesses(personne.orgUnitsParent, "Rituel").map((elem, key) => {
                        if (elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation) {
                          return (
                            <li key={key}>
                              - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                            </li>
                          );
                        }
                        return false;
                      })}
                      {afficheNonRenseigne(filterProcesses(personne.orgUnitsParent, "Rituel"))}
                    </ul>
                  </>
                ) : (
                  <>
                    {t("public.componentPersonne.rituelsGouvernance")} :
                    <ul>
                      <li>{t("public.componentPersonne.nonRenseigne")}</li>
                    </ul>
                  </>
                )}
                {filterProcesses(personne.orgUnitsParent, "Temps collectif").length ? (
                  <>
                    {t("public.componentPersonne.tempsCollectifs")} :
                    <ul>
                      {filterProcesses(personne.orgUnitsParent, "Temps collectif").map(
                        (elem, key) => {
                          if (elem.orgUnitParent !== ReduxInstance.orgunitPrincipalInOperation)
                            return (
                              <li key={key}>
                                - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                              </li>
                            );
                          return false;
                        }
                      )}
                      {afficheNonRenseigne(
                        filterProcesses(personne.orgUnitsParent, "Temps collectif")
                      )}
                    </ul>
                  </>
                ) : (
                  <>
                    {t("public.componentPersonne.tempsCollectifs")} :
                    <ul>
                      <li>{t("public.componentPersonne.nonRenseigne")}</li>
                    </ul>
                  </>
                )}
              </>
            )}
            {tabKey === "missions" && (
              <>
                {personne && (
                  <>
                    <div>
                      {t("public.componentPersonne.missionsInternes")}
                      {" : "}
                    </div>
                    {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).length ? (
                      <ul>
                        {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).map(
                          (elem, key) => {
                            if (
                              elem.orgUnitParent === ReduxInstance.orgunitPrincipalInOperation &&
                              elem.scope === "Interne"
                            )
                              return (
                                <li key={key}>
                                  - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                                </li>
                              );
                            return false;
                          }
                        )}
                        {afficheNonRenseigneScope(
                          filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]),
                          "Interne"
                        )}
                      </ul>
                    ) : (
                      <ul>
                        <li>{t("public.componentPersonne.nonRenseigne")}</li>
                      </ul>
                    )}

                    <div>
                      {t("public.componentPersonne.missionsExternes")}
                      {" : "}
                    </div>
                    {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).length ? (
                      <ul>
                        {filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]).map(
                          (elem, key) => {
                            if (
                              elem.orgUnitParent === ReduxInstance.orgunitPrincipalInOperation &&
                              elem.scope === "Externe"
                            )
                              return (
                                <li key={key}>
                                  - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                                </li>
                              );
                            return false;
                          }
                        )}
                        {afficheNonRenseigneScope(
                          filterProcesses(personne.orgUnitsParent, ["Rituel", "Mission"]),
                          "Externe"
                        )}
                      </ul>
                    ) : (
                      <ul>
                        <li>{t("public.componentPersonne.nonRenseigne")}</li>
                      </ul>
                    )}
                  </>
                )}
                {ReduxInstance.espacePrincipalColidee !== 0 && (
                  <>
                    {!lastContrib && personne.email !== "" && <ComponentLoader />}
                    {lastContrib && (
                      <>
                        <div>
                          {t("public.componentPersonne.lastContributionMission")} {" : "}
                        </div>
                        <ul>
                          <li>
                            {lastContrib.date && (
                              <>
                                {toDateTimeFR(lastContrib.date)}
                                <br />
                              </>
                            )}

                            {(!lastContrib.id_contribution || !personne.email) && (
                              <>{t("public.componentPersonne.nonRenseigne")}</>
                            )}
                            {lastContrib.id_contribution && personne.email !== "" && (
                              <a
                                href={
                                  process.env.REACT_APP_URL_COLIDEE +
                                  "o" +
                                  lastContrib.id_entreprise +
                                  "p" +
                                  lastContrib.id_plateforme +
                                  "/participation-" +
                                  lastContrib.id_contribution +
                                  ".htm"
                                }
                                target="_blank"
                                rel="noreferrer"
                              >
                                <ComponentThemesContribution contribution={lastContrib} />
                                {lastContrib.contribution}
                                {lastContrib.illustrationSmall && (
                                  <>
                                    <br />
                                    <Image
                                      src={lastContrib.illustrationSmall}
                                      style={{ maxWidth: "100%" }}
                                    />
                                  </>
                                )}
                              </a>
                            )}
                          </li>
                        </ul>
                      </>
                    )}
                  </>
                )}
              </>
            )}
            {tabKey === "roles" && personne && (
              <>
                {filterProcesses(personne.orgUnitsParent, "Rôle").length ? (
                  <ul>
                    {filterProcesses(personne.orgUnitsParent, "Rôle").map((elem, key) => {
                      return (
                        <li key={key}>
                          - <Link to={"/orgunits/" + elem._id}>{elem.nom}</Link>
                        </li>
                      );
                    })}
                  </ul>
                ) : (
                  <ul>
                    <li>{t("public.componentPersonne.nonRenseigne")}</li>
                  </ul>
                )}
              </>
            )}
            {tabKey === "participation" && (
              <>
                {!lastContribOnAllEspaces && <ComponentLoader />}

                {lastContribOnAllEspaces && (
                  <>
                    <div>{t("public.componentPersonne.lastContributionColidee")} :</div>

                    <ul>
                      <li>
                        {(!lastContribOnAllEspaces.id_contribution || !personne.email) && (
                          <>{t("public.componentPersonne.nonRenseigne")}</>
                        )}
                        {lastContribOnAllEspaces.id_contribution && personne.email !== "" && (
                          <a
                            href={
                              process.env.REACT_APP_URL_COLIDEE +
                              "o" +
                              lastContribOnAllEspaces.id_entreprise +
                              "p" +
                              lastContribOnAllEspaces.id_plateforme +
                              "/participation-" +
                              lastContribOnAllEspaces.id_contribution +
                              ".htm"
                            }
                            target="_blank"
                            rel="noreferrer"
                          >
                            <ComponentThemesContribution contribution={lastContribOnAllEspaces} />
                            {lastContribOnAllEspaces.contribution}
                            {lastContribOnAllEspaces.illustrationSmall && (
                              <>
                                <br />
                                <Image
                                  src={lastContribOnAllEspaces.illustrationSmall}
                                  style={{ maxWidth: "100%" }}
                                />
                              </>
                            )}
                            <br /> <br />
                            <span className="fst-italic">
                              {t("public.componentPersonne.postOn")}{" "}
                              {lastContribOnAllEspaces.nomEntreprise} >{" "}
                              {lastContribOnAllEspaces.nomPlateforme} <br />
                              {toDateTimeFR(lastContribOnAllEspaces.date)}
                            </span>
                          </a>
                        )}
                      </li>
                    </ul>
                  </>
                )}
              </>
            )}

            {tabKey === "profilmbti" && (
              <>
                {personne.lettresMbti?.length > 0 && (
                  <>
                    <h5 className="d-flex justify-content-center">{retourneLettresMBTI()}</h5>
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[0]}
                      leftLabel={t("public.componentPersonne.profilMbtiExtraversion")}
                      rightLabel={t("public.componentPersonne.profilMbtiIntroversion")}
                      color="#4ECDC4"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[1]}
                      leftLabel={t("public.componentPersonne.profilMbtiSensation")}
                      rightLabel={t("public.componentPersonne.profilMbtiIntuition")}
                      color="#F7DC6F"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[2]}
                      leftLabel={t("public.componentPersonne.profilMbtiPensee")}
                      rightLabel={t("public.componentPersonne.profilMbtiSentiment")}
                      color="#7DCEA0"
                      name="lettreMbti3"
                      isEditable={false}
                    />
                    <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[3]}
                      leftLabel={t("public.componentPersonne.profilMbtiJugement")}
                      rightLabel={t("public.componentPersonne.profilMbtiPerception")}
                      color="#BB8FCE"
                      isEditable={false}
                    />
                    {/* <ComponentRangeSlider
                      percentage={personne.lettresMbti?.[4]}
                      leftLabel={t("public.componentPersonne.profilMbtiAssertif")}
                      rightLabel={t("public.componentPersonne.profilMbtiTurbulent")}
                      color="#F1948A"
                      isEditable={false}
                    /> */}
                  </>
                )}
              </>
            )}
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};

export default PersonneCardInfo;
